module.exports = __webpack_public_path__ + "img/01_0_0_1.c31d1d84.png";